// Конфигурация приложения
const config = {
  // API настройки
  api: {
    // Используем относительный путь для работы через proxy в react-scripts
    // или полный URL из переменной окружения для продакшена
    baseUrl: process.env.REACT_APP_API_URL || '',
    endpoints: {
      search: '/api/search',
      statistics: '/api/statistics',
      userReport: '/api/userreport',
      userReportStatus: '/api/userreport/status',
      userReportYear: '/api/userreport/year',
      recentSearches: '/api/recent-searches',
      heartbeat: '/api/heartbeat',
      ragAsk: '/api/rag/ask',
      ragResult: '/api/rag/result'
    }
  },
  
  // Настройки приложения
  app: {
    name: 'Pikabulling - Поиск комментариев',
    version: '1.0.0',
    defaultLimit: 100,
    maxLimit: 1000
  },
  
  // Настройки UI
  ui: {
    contentPreviewLength: 500,
    dateFormat: 'dd.MM.yyyy HH:mm',
    locale: 'ru-RU'
  }
};

// Функция для получения полного URL API endpoint
export const getApiUrl = (endpoint) => {
  return `${config.api.baseUrl}${endpoint}`;
};

// Функция для получения конфигурации
export const getConfig = () => config;

export default config; 